var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResetIcon = function SvgResetIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H16V16H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.667 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.333,9.5A3.986,3.986,0,0,1,6.507,6.673L5.56,5.727a5.333,5.333,0,0,0,3.107,9.06V13.44A4,4,0,0,1,5.333,9.5Zm9.333,0A5.332,5.332,0,0,0,9.333,4.167c-.04,0-.08.007-.12.007l.727-.727L9,2.5,6.667,4.833,9,7.167l.94-.94-.72-.72c.04,0,.08-.007.113-.007A4,4,0,0,1,10,13.44v1.347A5.326,5.326,0,0,0,14.667,9.5Z",
    transform: "translate(-4 -2.5)",
    fill: "#828282"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResetIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset-icon.1214e049.svg";
export { ForwardRef as ReactComponent };